import styled from '@emotion/styled';

type StyledThumbnailImageProps = {
  src: string;
};

const StyledThumbnailImage = styled('figure')<StyledThumbnailImageProps>(
  ({ src }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url('${src}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  }),
);

export default StyledThumbnailImage;
